import React, { Suspense, lazy, useState } from 'react';

import { useLanguage } from '../../context/LanguageContext';

const ChatWidget = lazy(() => import('./ChatWidget').then(m => ({ default: m.ChatWidget })));

const ChatLauncherButton: React.FC<{
  onClick?: () => void;
  disabled?: boolean;
  label: string;
}> = ({ onClick, disabled = false, label }) => (
  <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex flex-col items-end">
    <button
      onClick={onClick}
      disabled={disabled}
      className="w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-105 active:scale-95 bg-natuvia-cta text-white disabled:cursor-wait disabled:opacity-80"
      aria-label={label}
      title={label}
      type="button"
    >
      <span className="text-2xl" aria-hidden="true">
        💬
      </span>
    </button>
  </div>
);

export const LazyChatWidget: React.FC = () => {
  const { language } = useLanguage();
  const [shouldLoad, setShouldLoad] = useState(false);
  const label = language === 'en' ? 'Open chat' : '開啟聊天';

  if (!shouldLoad) {
    return <ChatLauncherButton label={label} onClick={() => setShouldLoad(true)} />;
  }

  return (
    <Suspense fallback={<ChatLauncherButton label={label} disabled />}>
      <ChatWidget initialOpen />
    </Suspense>
  );
};
